import { Pipe, PipeTransform } from '@angular/core';
import { VorgangsTyp } from '../../domain/model/vorgangsTyp';

@Pipe({
    name: 'zuweisungErledigenReadable',
    standalone: false,
})
export class ZuweisungErledigenReadablePipe implements PipeTransform {

    transform(aufgabenTyp: VorgangsTyp): any {
        if (aufgabenTyp === VorgangsTyp.AUFGABE || aufgabenTyp == VorgangsTyp.ABWURFPUNKTE_AUFGABE) {
            return 'Vorgang erledigen';
        } else {
            return 'Zur Kenntnis genommen';
        }

    }

}
